import axios from 'axios'

const PANEL_SESSION_KEY = 'panelSession'
const ACCESS_TOKEN_KEY = 'accessToken'

let panelSessionRequest = null

export const getAccessToken = () => {
  const sessionToken = sessionStorage.getItem(ACCESS_TOKEN_KEY)

  if (sessionToken) {
    localStorage.removeItem(ACCESS_TOKEN_KEY)

    return sessionToken
  }

  const legacyToken = localStorage.getItem(ACCESS_TOKEN_KEY)
  if (legacyToken) {
    sessionStorage.setItem(ACCESS_TOKEN_KEY, legacyToken)
    localStorage.removeItem(ACCESS_TOKEN_KEY)

    return legacyToken
  }

  return null
}

export const setAccessToken = token => {
  localStorage.removeItem(ACCESS_TOKEN_KEY)

  if (!token) {
    sessionStorage.removeItem(ACCESS_TOKEN_KEY)
    delete axios.defaults.headers.common.Authorization

    return
  }

  sessionStorage.setItem(ACCESS_TOKEN_KEY, token)
  axios.defaults.headers.common.Authorization = `Bearer ${token}`
}

export const initializePanelAuth = () => {
  const token = getAccessToken()

  if (token) {
    axios.defaults.headers.common.Authorization = `Bearer ${token}`
  } else {
    delete axios.defaults.headers.common.Authorization
  }

  return token
}

export const getPanelSession = () => {
  const rawValue = sessionStorage.getItem(PANEL_SESSION_KEY) || localStorage.getItem(PANEL_SESSION_KEY)

  if (!rawValue) {
    return null
  }

  try {
    const session = JSON.parse(rawValue)
    localStorage.removeItem(PANEL_SESSION_KEY)
    sessionStorage.setItem(PANEL_SESSION_KEY, JSON.stringify(session))

    return session
  } catch (error) {
    localStorage.removeItem(PANEL_SESSION_KEY)
    sessionStorage.removeItem(PANEL_SESSION_KEY)

    return null
  }
}

export const setPanelSession = session => {
  if (!session) {
    localStorage.removeItem(PANEL_SESSION_KEY)
    sessionStorage.removeItem(PANEL_SESSION_KEY)

    return
  }

  localStorage.removeItem(PANEL_SESSION_KEY)
  sessionStorage.setItem(PANEL_SESSION_KEY, JSON.stringify(session))
}

export const clearPanelSession = () => {
  setAccessToken(null)
  localStorage.removeItem(PANEL_SESSION_KEY)
  sessionStorage.removeItem(PANEL_SESSION_KEY)
}

export const logoutPanelSession = async () => {
  try {
    await axios.post(`${process.env.VUE_APP_BASE_API_URL}panel/logout`, null, {
      timeout: 5000,
      withCredentials: true,
    })
  } catch (error) {
    // Client-side cleanup still happens even if the server-side cookie clear fails.
    if (process.env.NODE_ENV !== 'production') {
      console.warn(error)
    }
  } finally {
    clearPanelSession()
  }
}

export const fetchPanelSession = async (token = getAccessToken()) => {
  if (panelSessionRequest) {
    return panelSessionRequest
  }

  const requestConfig = {
    timeout: 8000,
    withCredentials: true,
  }

  if (token) {
    requestConfig.headers = {
      Authorization: `Bearer ${token}`,
    }
  }

  panelSessionRequest = axios.get(`${process.env.VUE_APP_BASE_API_URL}panel/session`, requestConfig).then(response => {
    const session = response?.data?.data

    if (!session?.id || (!session?.admin && !session?.finance)) {
      const error = new Error('Panel oturumu doğrulanamadı')
      error.panelAccessDenied = true
      throw error
    }

    if (token) {
      setAccessToken(token)
    }
    setPanelSession(session)

    return session
  }).finally(() => {
    panelSessionRequest = null
  })

  return panelSessionRequest
}

export const hasPanelAccess = (session = getPanelSession()) => !!(session && (session.admin || session.finance))

export const hasAdminAccess = (session = getPanelSession()) => !!session?.admin

export const hasFinanceAccess = (session = getPanelSession()) => !!(session && (session.admin || session.finance))
